<app-header></app-header>

<section class="login">
  <h1>
    {{ "ACCOUNT_CREATED" | translate }}
  </h1>
</section>
